import { memo } from 'react';

import { useFormatNumber } from '~/i18n/hooks/useFormatNumber/useFormatNumber';

import { FormatNumberOptions } from '../../types/FormatNumberOptions';
import { Text } from '../Text/Text';

interface Props {
  /** JS `number` */
  number?: number | number[];
  /** status to use for text color. */
  status?: 'active' | 'danger' | 'success';
  /** Formatting options */
  options?: FormatNumberOptions;
}

export const NumberText = memo(({ number, status, options }: Props) => {
  const formatNumber = useFormatNumber();

  const formattedNumbers = Array.isArray(number)
    ? number.map((item) => formatNumber(item, options)).join(' • ')
    : formatNumber(number, options);

  return (
    <Text color={status ? `status.${status}` : 'text.primary'}>
      {formattedNumbers}
    </Text>
  );
});
